'use clinet'

import { NavContext } from "@/context/navContext"
import logo_pc from "@/public/image/logo/logo_pc.png"
import logo_mo from "@/public/image/logo/logo_mo.png"
import logo_mo_page from "@/public/image/logo/logo_mo_page.png"
import { useContext } from "react"
import { usePathname } from "next/navigation"
import { DeviceContext } from "@/context/deviceContext"

export default function Logo() {
    const { mobileMode } = useContext(DeviceContext)
    // const { movePage } = useContext(NavContext)
    const pathName = usePathname()
    return (
        // <div className="logo-container" onClick={e => movePage('/')}>
        <div className="logo-container" onClick={e => window.location.href = '/'}>
            {/* <span className="default-logo">LOGO</span> */}
            {
                // mobileMode
                //     ? <img src={logo_mo.src} alt="logo" className="logo"  />
                //     : <img src={logo_pc.src} alt="logo" className="logo"  />
                <div className={`pageLogoArea`}></div>
            }            
            {/* {
                pathName == '/'
                    ? <img src={logo_mo.src} alt="logo" className="logo" width={190} height={96}  />
                    : <img src={logo_mo_page.src} alt="logo" className="logo"  />
            }             */}
        </div>
    )
}